"use strict";
/*
 * Created on 9. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

/**
 * @author Stepan Mik
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KpiUnit;

(function (KpiUnit) {
  KpiUnit["Percent"] = "PERCENT";
  KpiUnit["Volume"] = "VOLUME";
  KpiUnit["Currency"] = "CURRENCY";
  KpiUnit["Price"] = "PRICE";
  KpiUnit["Segment"] = "SEGMENT";
  KpiUnit["Promille"] = "PROMILLE";
  /**
   * Number of days actual stock will suffice for. Maximum value is 14. Values greater than 14 should be displayed as 14+
   */

  KpiUnit["StockDays"] = "STOCK_DAYS";
})(KpiUnit = exports.KpiUnit || (exports.KpiUnit = {}));